export const generateAutomationId = () => {
  if ('crypto' in window) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).substring(2, 15);
};
